import BookingsService from '@/shared/types/bookings/service.type';

import BookingContactForm from '../types/bookingContactForm.type';

const transformBookingServiceToContactForm = (
  bookingService: BookingsService,
): BookingContactForm[] => {
  const contactMap = new Map<string, string[]>();

  for (const contact of bookingService.contacts) {
    const calendarIds = contactMap.get(contact.booking_contact_id) || [];
    calendarIds.push(contact.calendar_id);
    contactMap.set(contact.booking_contact_id, calendarIds);
  }

  const transformedContacts: BookingContactForm[] = [];

  for (const [booking_contact_id, calendar_ids] of contactMap.entries()) {
    transformedContacts.push({
      booking_contact_id,
      calendar_ids,
    });
  }

  return transformedContacts;
};

export default transformBookingServiceToContactForm;
